import { faMessage } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import 블렌더연습2 from "./img/블렌더연습20.png";
import olympus from "./img/olympus.jpg";
import software from "./img/software/개요이미지1.png";
import medicine from "./img/medicine.jpg";
import rtms from "./img/software/rtms.png";

import arrowright from "./img/icon/arrowright.png";
import dompurify from "dompurify";
import { useTranslation } from "react-i18next";
import i18next from "../config/lang/i18next";
import Cookies from "universal-cookie";
const cookies = new Cookies();
const Home = () => {
  const { t, i18n } = useTranslation();
  const sanitizer = dompurify.sanitize;
  const language = useRef(null);

  useEffect(() => {
    language.current = sessionStorage.getItem("language");
    if (language === null) {
      language.current = cookies.get("language");
    }
    i18next.changeLanguage(language.current);
  }, []);
  /* css 애니메이션 효과 */
  function reveal() {
    var fades = document.querySelectorAll(".fade-up");
    /*var titles = document.querySelectorAll(".title-wrap");
    var reveals = document.querySelectorAll(".reveal");*/
    for (var i = 0; i < fades.length; i++) {
      var windowHeight = window.innerHeight;
      var elementTop = fades[i].getBoundingClientRect().top;
      var elementVisible = 150;
      if (elementTop < windowHeight - elementVisible) {
        fades[i].classList.add("fadeInUp");
      } else {
        fades[i].classList.remove("fadeInUp");
      }
    }

    var fades2 = document.querySelectorAll(".animate_img");
    var reveals = document.querySelectorAll(".animate_text");
    for (var j = 0; j < fades2.length; j++) {
      var windowHeight2 = window.innerHeight;
      var elementTop2 = fades2[j].getBoundingClientRect().top;
      var elementVisible2 = 150;
      if (elementTop2 < windowHeight2 - elementVisible2) {
        fades2[j].classList.add("visible");
      } else {
        fades2[j].classList.remove("visible");
      }
    }
    for (var k = 0; k < reveals.length; k++) {
      var wH = window.innerHeight;
      var eT = reveals[k].getBoundingClientRect().top;
      var eV = 150;
      if (eT < wH - eV) {
        reveals[k].classList.add("visible");
      } else {
        reveals[k].classList.remove("visible");
      }
    }
  }
  window.addEventListener("scroll", reveal);

  // To check the scroll position on page load
  reveal();

  /* 메인페이지 뉴스 top 3 불러오기 */

  const [data, setData] = useState([]);
  const [filterData, setfilterData] = useState([]);

  useEffect(() => {
    axios.get("https://thegmmedical.com:5002/api/mainboard").then((response) => {
      setData(response.data);
      setfilterData(response.data);
      console.log(filterData);
      if (response.data === undefined) {
        return "...";
      } // data 가 undefined 일 시
    });
  }, []);

  return (
    <div className="wrap">
      <style>
        {`
    
    `}
      </style>

      <div className="main_visual">
        <div className="blendImg">
          <div className="text-wrapper">
            <div className="text-render text-s">
              <div className="eyebrow"></div>

              <h2 className="headline is-hidden-mobile fadeInUp" style={{fontSize:"75px"}}>
                GM Medical
              </h2>

              <p className="description mobilehide" style={{fontSize:"40px"}}>
                innovative solutions for the future of healthcare
              </p>
              <p className="description" style={{fontSize:"20px", fontWeight:"normal", fontFamily:"Pretendard-Light"}}>
              {i18next.t("main.first")}
              </p>
              {/*<div className="main_container">
          <a className="main_arrow" href="/capabilities/sustainability/our-insights/a-devilish-duality-how-ceos-can-square-resilience-with-net-zero-promises" target="" aria-label="">5 core actions</a>
  </div>*/}
            </div>
          </div>

        </div>

        <div className="scroll-downs">
          <div className="mousey">
            <div className="scroller"></div>
          </div>
        </div>
      </div>

      <div className="row1">
        <div className="content-block">
          <div className="fade-up">
            <div className="eyebrow text-green-regular  svelte-16unb9k">
              Introducing
            </div>
          </div>
          <div className="title fade-up">
            <div>
              <h2 className="fade-up">
              {i18next.t("main.second")}
              </h2>
              <p></p>
            </div>
          </div>{" "}
          <div className="fade-up headline-stick"></div>{" "}
          <div>
            <div className="fade-up">
              <p>
                GM MEDICAL aims to provide reliable healthcare services for customers and constantly provice innovative technologies to build a convenient future healthcare system.
              </p>
            </div>
          </div>
          <div className="center">
            <button className="btn">
              <svg
                width="180px"
                height="60px"
                viewBox="0 0 180 60"
                className="border"
              >
                <polyline
                  points="179,1 179,59 1,59 1,1 179,1"
                  className="bg-line"
                />
                <polyline
                  points="179,1 179,59 1,59 1,1 179,1"
                  className="hl-line"
                />
              </svg>
              <span>LEARN MORE</span>
            </button>
          </div>
        </div>
      </div>

      <div className="row2">
        <div className="row2_wrapper">
          <div className="img_wrap animate_img">
            <img src={olympus} alt="컴퓨터요"></img>
          </div>

          <div className="desc animate_text">
            <div className="desc_wrap">
              <div className="product_header">
                <h2 className="underscore">
                  {i18next.t("main.second_row.1.title")}
                </h2>
              </div>
              <div className="product_desc">
                {i18next.t("main.second_row.1.summary")}{" "}
              </div>
              <a className="more_btn" href="/device" title="뉴스더보기">
                <span>{i18next.t("main.more")}</span>
                <img src={arrowright} alt="more"></img>
              </a>
            </div>
          </div>
        </div>
        <div className="row2_wrapper">
          <div className="img_wrap animate_img">
            <img
              src={software}
              alt="컴퓨터요"
              style={{ objectFit: "contain" }}
            ></img>
          </div>
          <div className="desc animate_text">
            <div className="desc_wrap">
              <div className="product_header">
                <h2 className="underscore">
                  {i18next.t("main.second_row.2.title")}
                </h2>
              </div>
              <div className="product_desc">
                {i18next.t("main.second_row.2.summary")}
              </div>
              <a className="more_btn" href="/software" title="뉴스더보기">
                <span>{i18next.t("main.more")}</span>
                <img src={arrowright} alt="more"></img>
              </a>
            </div>
          </div>
        </div>

        <div className="row2_wrapper">
          <div className="img_wrap animate_img">
            <img src={medicine} alt="컴퓨터요"></img>
          </div>

          <div className="desc animate_text">
            <div className="desc_wrap">
              <div className="product_header">
                <h2 className="underscore">
                  {i18next.t("main.second_row.3.title")}
                </h2>
              </div>
              <div className="product_desc">
                {i18next.t("main.second_row.3.summary")}
              </div>
              <a className="more_btn" href="/medicine" title="뉴스더보기">
                <span>                    
                  {i18next.t("main.more")}
                </span>
                <img src={arrowright} alt="more"></img>
              </a>
            </div>
          </div>
        </div>
      </div>

      <section className="row_news overflow-hidden py-10 md:py-20 relative svelte-am2ffe lazyloaded">
        <div className="container ">
          <div className="mx-auto   svelte-am2ffe">
            <div className="content-block fade-in-bottom text-left svelte-1be2l8v fade-in-bottom-animate">
              <div className="title richtext-block relative">
                <div className="rich-text-block">
                  <h2 id="latest-news-and-blog-posts">
                    Latest news and blog posts
                  </h2>
                </div>
              </div>
            </div>
            <div className="row_news_flex">
              {filterData.map(
                ({
                  board_id,
                  subject,
                  board_date,
                  image_link,
                  content_txt,
                }) => (
                  <a
                    className="card-wrapper"
                    href={"/news/view/" + board_id}
                    target="_blank"
                    rel="noopener noreferrer"
                    key={board_id}
                  >
                    <div className="card">
                      <div className="cardImage">
                        <img alt={subject} src={image_link} />
                        
                      </div>
                      <div className="cardContent">
                        <h5>{subject}</h5>

                        <div className="body">{content_txt}</div>
                      </div>
                    </div>
                  </a>
                )
              )}
            </div>
          </div>
          <a className="btn artc news" href="/news" title="뉴스더보기">
            <img src={arrowright} alt="more"></img>
            <span>more</span>
          </a>
        </div>

        {/* 
<div className="cta " style={{display:"flex", justifyContent:"center"}}><a target="_self" className="btn inline-block cursor-pointer green normal svelte-lt6zv4" href="/get-started/what-is-iota"> <div className="py-4 px-6 grow">
  SEE ALL POSTS</div></a>
</div>
*/}
      </section>

      <div className="purple-to-blue-gradient-bg link_inquiry">
        <div className="contact-container">
          <div style={{ height: "90px" }} aria-hidden="true"></div>

          <div className="contact-inner-container">
            <div style={{ flexBasis: "70%" }}>
              <h4 style={{ 
    fontSize: "60px",
    
    fontWeight: "700",
    lineHeight: "70px",
    marginBottom: "20px"}}>
              Contact us

              </h4>

       
            </div>

            <div style={{ flexBasis: "30%", marginTop:"30px" }}>
              <div>
                <a href="/inquiry">
                  <div
                    className="contact-block-button"
                    id="chatwithsales"
                    style={{ background:"white" }}
                  >
                    <i className="fa fa-comments-o" aria-hidden="true"></i>
                    
                    
                    {i18next.t("main.inquiry")}

                    <FontAwesomeIcon icon={faMessage} />
                  </div>
                </a>
              </div>
            </div>
          </div>

          <div
            style={{ height: "90px" }}
            aria-hidden="true"
            className="wp-block-spacer"
          ></div>
        </div>
      </div>
    </div>
  );
};

export default Home;
